import { render, staticRenderFns } from "./CompanySynonymsTableRow.vue?vue&type=template&id=aa13717c&scoped=true&"
import script from "./CompanySynonymsTableRow.vue?vue&type=script&lang=js&"
export * from "./CompanySynonymsTableRow.vue?vue&type=script&lang=js&"
import style0 from "./CompanySynonymsTableRow.vue?vue&type=style&index=0&id=aa13717c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa13717c",
  null
  
)

export default component.exports